export enum Orientation {
  portrait = "portrait",
  landscape = "landscape",
}

export enum Page {
  Home = "/",
  Floorplan = "/floorplan",
  MeetingRoom = "/meeting-room",
  Office = "/office",
  Studio = "/studio",
  RVSRegister = "/rvs-register",
  Print = "/print",
  UkoPrint = "/uko-print",
}

export enum CombinedMeetingRoom {
  TwoThree = "2 + 3 (",
  TwoThreeFour = "2 + 3 + 4",
  ThreeFour = "3 + 4 (",
  TwoThreeFourFive = "2 + 3 + 4 +",
}

export enum Entrance {
  top = "top",
  bottom = "bottom",
}

export enum FloorplanImage {
  top = "/meeting-room-top.webp",
  bottom = "/meeting-room-bottom.webp",
}
